module.exports = __webpack_public_path__ + "static/media/icomoon.b2e5b09c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon/icomoon.ttf
// module id = 1162
// module chunks = 110